import { VatNumberValidationCountrySettings } from '../../model/vat-number-validation'

const KERTOIMET = [8, 7, 6, 5, 4, 3, 2]

const onkoTavallinenTaiYritysnumero = (numero: string): boolean => {
  if (Number(numero) === 0) {
    return false
  }
  const runko = Number(numero.slice(0, 7))
  let summa = 0
  for (let i = 0; i < KERTOIMET.length; i++) {
    summa += Number(numero.charAt(i)) * KERTOIMET[i]
  }
  let tarkiste = summa
  while (tarkiste > 0) {
    tarkiste -= 97
  }
  tarkiste = Math.abs(tarkiste)
  const odotettu = Number(numero.slice(7, 9))
  if (tarkiste === odotettu && runko < 9990001 && (runko < 100000 || runko > 999999) && (runko < 9490001 || runko > 9700000)) {
    return true
  }
  // Uudet numerot käyttävät modulo 97 -tarkistetta, josta on vähennetty 55, joten numero voi olla kumpaa tahansa mallia
  tarkiste = tarkiste >= 55 ? tarkiste - 55 : tarkiste + 42
  return tarkiste === odotettu && runko > 1000000
}

export const northernIreland: VatNumberValidationCountrySettings = {
  name: 'Northern Ireland',
  code: 'XI',
  calcFn: (vat: string): boolean => {
    if (vat.startsWith('GD')) {
      return Number(vat.slice(2, 5)) < 500
    }
    if (vat.startsWith('HA')) {
      return Number(vat.slice(2, 5)) > 499
    }
    return onkoTavallinenTaiYritysnumero(vat.slice(0, 9))
  },
  rules: {
    multipliers: { common: KERTOIMET },
    regex: [/^(XI)(\d{9})$/, /^(XI)(\d{12})$/, /^(XI)(GD\d{3})$/, /^(XI)(HA\d{3})$/],
  },
}
// MIT licensed code from https://github.com/se-panfilov/jsvat/blob/master/ (C) 2015 Sergei Panfilov
